import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useQuery } from '@tanstack/vue-query';
import { MaybeRefOrGetter } from '@vueuse/core';

import { getDateDiffFromNow } from '~~core';

import { fetchCAFCredentials } from '../services/caf';

const CAF_TOKEN_EXPIRATION_BUFFER_MS = 500;
const CAF_TOKEN_REFRESH_FALLBACK_MS = 10;

export const CAFQueryKeys = createQueryKeys('CAF', {
  credentials: (requirementKey: MaybeRefOrGetter<string>) => [{ requirementKey }],
});

export function useFetchCAFCredentials(requirementKey: MaybeRefOrGetter<string>) {
  const staleTime = useState('caf_credentials_stale_time', () => 0);

  const result = useQuery({
    queryKey: CAFQueryKeys.credentials(requirementKey).queryKey,
    staleTime,
    refetchOnWindowFocus: false,
    refetchInterval(data) {
      if (!data) return CAF_TOKEN_REFRESH_FALLBACK_MS;

      return getDateDiffFromNow(data.tokenExpiresAt) - CAF_TOKEN_EXPIRATION_BUFFER_MS;
    },

    queryFn: async () => {
      const data = await fetchCAFCredentials(toValue(requirementKey));

      staleTime.value = getDateDiffFromNow(data.tokenExpiresAt);

      return data;
    },
  });

  return {
    ...result,
    credentials: result.data,
  };
}
